import { DateType } from "react-tailwindcss-datepicker";

export enum InteractionMode {
  PHONE = "Phone Call",
  VIDEO = "Video Chat",
  SMS = "Text Message",
  EMAIL = "Email",
  IN_PERSON = "In-Person",
  LETTER = "Letter",
  LIVE_CHAT = "Live Chat"
}

export type Message = {
  content: string;
  createdAt: Date;
  fromOwner: boolean;
  fromProfilePhoto: string;
  isPrivate: boolean;
  haveAccess: boolean;
};

export type Interaction = {
  id: string;
  mode: InteractionMode;
  owner: {
    name: string;
    email: string;
  } | null;
  relatedTo: string;
  participants: {
    firstName: string;
    lastName: string;
    pgaId: string;
    profilePhoto: string;
    currentStatus: string;
    employments: {
      isPrimary: boolean;
      facility: {
        name: string;
      };
    }[];
    classification: string;
    primarySectionAffiliation?: {
      section: {
        name: string;
      };
    };
  }[];
  categories: string[];
  messagesCount: number;
  lastMessage: Message;
  messages: Message[];
  summary: string;
  interactionDate: Date;
  lastModifiedDate: Date | string;
  createdAt: Date | string;
  jobPost?: {
    id: string;
    name: string;
    facility?: {
      name: string;
    };
  };
  showAiSummary: boolean;
  openTasksCount?: number;
  twilioFlexCall?: {
    callSid?: string | null;
    transcriptSummaryStatus: string;
    transcriptSummary?: string | null;
    transcriptTopic?: string | null;
    transcriptSubtopic?: string | null;
    transcriptTopicConfidence?: number | null;
    sentimentLabel?: string | null;
    sentimentSource?: string | null;
    workerName?: string | null;
    direction?: string | null;
    durationSeconds?: number | null;
    queueTimeSeconds?: number | null;
    recordingUrl?: string | null;
    firstContactOnIssue?: string | null;
    failedPriorContact?: boolean | null;
    failedPriorContactDetail?: string | null;
    callerState?: string | null;
    issueCount?: number | null;
  } | null;
  _permissions: String[];
};

export type InteractionRecipient = {
  id: string;
  name: string;
  email: string;
};

export type InteractionStats = {
  totalInteractions: number;
  totalPhoneInteractions: number;
  totalVideoInteractions: number;
  totalSmsInteractions: number;
  totalEmailInteractions: number;
  totalInPersonInteractions: number;
};

export type InteractionInput = {
  participantId?: string | null;
  interactionDate: string | null | DateType;
  mode: string | undefined | null;
  activityType?: string | null;
  categories?: string[] | null;
  description: string | null;
  participantIds?: string[] | null;
  privacy_restricted?: boolean;
  memberFeedback?: boolean;
  jobPostId?: string | null;
  sectionId?: string | null;
};

export type SummaryPayload = {
  mode: string | null;
  subject: string | null;
  comments: string | null;
};

export type AiResponse = {
  message: string;
  loading: boolean;
  error: any;
};

export type ApiMode =
  | "Phone Call"
  | "Video Chat"
  | "Email"
  | "In-Person"
  | "Text Message"
  | "Live Chat"
  | "Other"
  | "Letter";

export type InteractionsMap = { [key: string]: Interaction[] };
